import axios from 'axios'
import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    agents: [],
    count: 0,
    agentCodes: [],
    agentCodesCnt: 1,

    agent: null,

    agentUsers: [],
    agentUsersCnt: 1
  },
  mutations: {
    SET_AGENTS (state, agents) {
      state.agents = agents
    },
    SET_COUNT (state, count) {
      state.count = count
    },
    SET_AGENT_CODES (state, data) {
      state.agentCodes = data
    },

    SET_AGENT_CODES_CNT (state, data) {
      state.agentCodesCnt = data.total
    },

    SET_AGENT_USERS (state, data) {
      state.agentUsers = data
    },

    SET_AGENT_USERS_CNT (state, data) {
      state.agentUsersCnt = data.total
    },

    SET_AGENT (state, data) {
      state.agent = data
    }
  },
  getters: {},
  actions: {
    async get ({ commit }, { params, status }) {
      let jsonHardSorts = {
        'bank_account_name': {
          process (data, sort) {
            if (sort) {
              return _.sortBy(data, e => {
                let chosen = []
                chosen.push(_.find(e.wallets, dd => dd.is_main))
                if (!chosen[0]) { chosen = e.wallets }
                return chosen[0].bank_account_name.toLowerCase()
              })
            } else {
              return _.sortBy(data, e => {
                let chosen = []
                chosen.push(_.find(e.wallets, dd => dd.is_main))
                if (!chosen[0]) { chosen = e.wallets }
                return chosen[0].bank_account_name.toLowerCase()
              }).reverse()
            }
          }
        },
        'bank_account_number': {
          process (data, sort) {
            if (sort) {
              return _.sortBy(data, e => {
                let chosen = []
                chosen.push(_.find(e.wallets, dd => dd.is_main))
                if (!chosen[0]) { chosen = e.wallets }
                return chosen[0].bank_number.toLowerCase()
              })
            } else {
              return _.sortBy(data, e => {
                let chosen = []
                chosen.push(_.find(e.wallets, dd => dd.is_main))
                if (!chosen[0]) { chosen = e.wallets }
                return chosen[0].bank_number.toLowerCase()
              }).reverse()
            }
          }
        },
        'bank_name': {
          process (data, sort) {
            if (sort) {
              return _.sortBy(data, e => {
                let chosen = []
                chosen.push(_.find(e.wallets, dd => dd.is_main))
                if (!chosen[0]) { chosen = e.wallets }
                return chosen[0].bank_name.toLowerCase()
              })
            } else {
              return _.sortBy(data, e => {
                let chosen = []
                chosen.push(_.find(e.wallets, dd => dd.is_main))
                if (!chosen[0]) { chosen = e.wallets }
                return chosen[0].bank_name.toLowerCase()
              }).reverse()
            }
          }
        }
      }
      let defaultSorter = (data, sort, sortBy) => {
        if (sort == 'asc') { return _.sortBy(data, e => e[sortBy]) } else { return _.sortBy(data, e => e[sortBy]).reverse() }
      }

      let agents = await axios.get(`/agents/${status}`, { params })
      let dataPass = agents.data
      if (jsonHardSorts[params.sort_by]) {
        dataPass = jsonHardSorts[params.sort_by].process(dataPass, (params.sort == 'asc'))
      } else {
        dataPass = defaultSorter(dataPass, params.sort, params.sort_by)
      }

      let count = await axios.get(`/agents/${status}/count`, { params })
      commit('SET_AGENTS', dataPass)
      commit('SET_COUNT', count.data)
    },

    async create ({ commit }, data) {
      return axios.post('/agents', data)
    },

    async update ({ commit }, { id, data }) {
      return axios.patch(`/agents/${id}`, data)
    },

    async delete ({ commit }, id) {
      return axios.delete(`/agents/${id}`)
    },

    async archive ({ commit }) {
      let result = await axios.get('/agents/archive')

      commit('SET_AGENTS', result.data)
    },

    async find ({ commit }, { id }) {
      try {
        let response = await axios
          .get(`/agents/${id}/agent`)
        commit('SET_AGENT', response.data[0])
      } catch (err) {
      }
    },

    async getCodes ({ commit }, { id, params }) {
      try {
        let p = _.map(params, (v, k) => encodeURIComponent(k) + '=' + encodeURIComponent(v)).join('&')
        let response = await axios.get(`/codes/${id}/agent?${p}`)
        commit('SET_AGENT_CODES', response.data)

        let count = await axios.get(`/codes/${id}/agent/count?${p}`)
        commit('SET_AGENT_CODES_CNT', count.data[0])
      } catch (err) {

      }
    },

    async  getUserList ({ commit }, { id, params, status }) {
      try {
        let response = await axios.get(`/agents/${status}/${id}/user-list`, { params })
        commit('SET_AGENT_USERS', response.data)
        let count = await axios.get(`/agents/${status}/${id}/user-list/count`, { params })
        commit('SET_AGENT_USERS_CNT', count.data[0])
      } catch (err) {

      }
    }
  }
}
